import { request } from 'shared/lib/request';

export const getEmployees = ({ companyId, dateStart, dateEnd }) =>
  request.get(`/companies/${companyId}/employees/`, {
    params: { dateStart, dateEnd },
  });

export const getEmployeesWithAbsences = ({
  companyId,
  startDate,
  endDate,
  siret,
  contract,
  name,
  position,
  classification,
  page,
  limit,
  sort,
}) =>
  request.get(`/companies/${companyId}/employee-absences/`, {
    params: {
      startDate,
      endDate,
      siret,
      contract,
      name,
      position,
      classification,
      page,
      limit,
      sort,
    },
  });

export const setEmployeeSchedule = (payload) =>
  request.post(
    `/companies/${payload.companyId}/schedules/${payload.scheduleId}`,
    {
      employeeId: payload.employeeId,
    }
  );

export const downloadEmployeeTableXLSX = (payload) => {
  const { companyId, query } = payload;

  return request.get(`/companies/${companyId}/employees/xlsx?${query}`, {
    responseType: 'blob',
  });
};

export const fetchDownloadEmployeePayslips = ({
  companyId: dosId,
  employeeId,
  startDate,
  endDate,
}) =>
  request.get(`/companies/${dosId}/employees/${employeeId}/payslips/pdf`, {
    params: {
      startDate,
      endDate,
    },
    responseType: 'blob',
  });

export const fetchDownloadCompanyEmployeesPayslips = ({
  companyId: dosId,
  startDate,
  endDate,
}) =>
  request.get(`/companies/${dosId}/payslips/pdf`, {
    params: {
      startDate,
      endDate,
    },
    responseType: 'blob',
  });

export const fetchDownloadCompanyEmployeesPdf = ({
  companyId: dosId,
  startDate,
  endDate,
  key,
}) =>
  request.get(`/companies/${dosId}/${key}/pdf`, {
    params: {
      startDate,
      endDate,
    },
    responseType: 'blob',
  });

export const fetchDownloadCompanyEmployeesPayslipsZip = ({
  companyId: dosId,
  startDate,
  endDate,
}) =>
  request.get(`/companies/${dosId}/payslips/zip`, {
    params: {
      startDate,
      endDate,
    },
    responseType: 'blob',
  });
